import React, { useEffect } from 'react';
import { BonusSection } from './components/BonusSection';
import { ClosingSection } from './components/ClosingSection';
import { FAQ } from './components/FAQ';
import { FinalCta } from './components/FinalCta';
import { Footer } from './components/Footer';
import { GuaranteeSection } from './components/GuaranteeSection';
import { Hero } from './components/Hero';
import { LookInsideCarousel } from './components/LookInsideCarousel';
import { MetaPixel } from './components/MetaPixel';
import { ModulesSection } from './components/ModulesSection';
import { PricingSection } from './components/PricingSection';
import { ProblemSection } from './components/ProblemSection';
import { PurchaseNotification } from './components/PurchaseNotification';
import { SummaryTable } from './components/SummaryTable';
import { SystemSection } from './components/SystemSection';
import { UrgencySection } from './components/UrgencySection';
import { productShortName } from './data/offer';
const pageDescription = 'Understand El Niño, read the forecasts correctly and prepare industrial sites for floods, heat, drought and energy disruptions. 6 professional volumes, 5 exclusive bonuses and instant access.';
export function App() {
  useEffect(() => {
    document.title = productShortName;
    const setMeta = (attr: 'name' | 'property', key: string, content: string) => {
      let tag = document.head.querySelector<HTMLMetaElement>(`meta[${attr}="${key}"]`);
      if (!tag) {
        tag = document.createElement('meta');
        tag.setAttribute(attr, key);
        document.head.appendChild(tag);
      }
      tag.setAttribute('content', content);
    };
    setMeta('name', 'description', pageDescription);
    setMeta('property', 'og:title', productShortName);
    setMeta('property', 'og:description', pageDescription);
  }, []);
  return <div className="storm-bg min-h-screen w-full overflow-hidden font-sans text-muted antialiased" data-id="element-0" data-mp="nvasltl5rjh6">
      <MetaPixel data-id="element-1" data-mp="ssstcwp0use3" />
      <main data-id="element-2" data-mp="swgi7ijiuqmh">
        <Hero data-id="element-3" data-mp="3686tkdjumw2" />
        <LookInsideCarousel data-id="element-4" data-mp="35oz0whm5evr" />
        <ProblemSection data-id="element-5" data-mp="34x13f0jn52b" />
        <SystemSection data-id="element-6" data-mp="38ktgau95lfg" />
        <ModulesSection data-id="element-7" data-mp="3ud1ff9ao9oam" />
        <BonusSection data-id="element-8" data-mp="3ubrg6gs32a2e" />
        <UrgencySection data-id="element-9" data-mp="3uc9inv5c9kir" />
        <PricingSection data-id="element-10" data-mp="3uf5hdlp0gd89" />
        <GuaranteeSection data-id="element-11" data-mp="d57g95652mk4" />
        <FAQ data-id="element-12" data-mp="d3cu5nj4soeg" />
        <ClosingSection data-id="element-13" data-mp="d45uo6rhyho5" />
        <SummaryTable data-id="element-14" data-mp="d2bjhk6123x9" />
        <FinalCta data-id="element-15" data-mp="85ully910b6z" />
      </main>
      <Footer data-id="element-16" data-mp="86w6eufugc1w" />
      <PurchaseNotification data-id="element-17" data-mp="864d5q9pyqes" />
    </div>;
}